import { Variants, Easing } from 'framer-motion';
const LOAD_DURATION = 0.4;
const EXIT_DURATION = 0.3;
const LOAD_DELAY = 0.2;
const EXIT_DELAY = 0;


//TODO: scroll bar showing up when in transition

export const containerVariants: Variants = {
  initialLoad: {
    opacity: 0,
  },
  fullLoad: {
    opacity: 1,
    transition: {
      ease: "easeIn",
      delay: LOAD_DELAY,
      duration: LOAD_DURATION,
    },
  },
  offLoad: {
    opacity: 0,
    transition: {
      delay: EXIT_DELAY,
      duration: EXIT_DURATION,
    },
  },
};

export const fadeInOut_container = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 1 },
}


export const expand_container = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: 'auto' },
  exit: { opacity: 0, height: 0 },
  transition: { duration: 0.3 }
}


export const fadeInOut_image = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.95 },
  transition: { duration: 0.5, ease: 'easeInOut' as Easing }
};


export const slideInFromRight = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};


